export default import.meta.ROLLDOWN_FILE_URL_XthUuxpXiyf13t3prDpdbw